import { Outlet } from 'react-router-dom';

export function App() {
  return (
    <div className="min-h-full">
      <Outlet />
    </div>
  );
}
